<!-- components/CustomDialog.vue -->
<template>
    <div class="dialog-overlay">
        <el-dialog
            v-model="show"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="800"
            :class="
                ['dialog_stick', 'dialog_main', 'dialog_img', 'dialog_bubble'][noticeData.type - 1]
            "
        >
            <div class="dialog_header" v-if="noticeData.type == 1">
                <div class="header_chat">
                    <img class="chatAi" src="@/assets/dialog/4.png" alt="" />
                </div>
                <div class="dialog_title">{{ noticeData.title }}</div>
            </div>

            <div class="dialog_header" v-else-if="noticeData.type == 2">
                {{ noticeData.title }}
            </div>

            <div class="dialog_header" v-else-if="noticeData.type == 3">
                <img class="img" src="@/assets/dialog/5.png" alt="" />
                <div class="header_center_title">
                    {{ noticeData.title }}
                </div>
            </div>

            <div class="dialog_header" v-else-if="noticeData.type == 4">
                <img class="img" src="@/assets/dialog/4.png" alt="" />
                <div class="dialog_title">{{ noticeData.title }}</div>
            </div>

            <div class="dialog_content">
                <el-scrollbar max-height="45vh" style="width: 100%" always>
                    <!--          <div class="content" v-html="noticeData.content"></div>-->
                    <Editor
                        v-model="noticeData.content"
                        :defaultConfig="editorConfig"
                        mode="default"
                        @onCreated="handleCreated"
                    />
                </el-scrollbar>
            </div>

            <div class="dialog_footer">
                <img
                    v-if="noticeData.type == 1"
                    class="dialog_icon"
                    src="@/assets/dialog/1.png"
                    alt=""
                />
                <img
                    v-if="noticeData.type == 3"
                    class="dialog_icon"
                    src="@/assets/dialog/6.png"
                    alt=""
                />
                <div class="dialog_btn">
                    <div class="btn" @click="read">我知道了</div>
                    <!--    v-if="props.type == 'default'"      -->
                    <el-checkbox
                        v-if="props.type == 'default'"
                        class="tips"
                        v-model="checked"
                        label="不再提示"
                        size="large"
                    />
                    <div v-else class="checkboxNull"></div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted, shallowRef, onBeforeUnmount } from 'vue'
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import api from '@/api/api'
import { Editor } from '@wangeditor/editor-for-vue'

const props = defineProps({
    type: {
        default: 'default'
    },
    data: {
        default: {}
    }
})
const emit = defineEmits(['close', 'confirm'])

const editorRef = shallowRef()
const show = ref(false)
const checked = ref(false)
const editorConfig = ref({
    readOnly: true
})
const noticeData = ref({
    title: '',
    content: '',
    type: 1
})

// 已读
const read = () => {
    // 勾选了4小时内不提示公告
    // let nextTime = Date.now() + (60 * 1000 * 60 * 4);
    // localStorage.setItem("nextTime", nextTime)
    if (props.type != 'default') return emit('close')
    if (checked.value) {
        api.noticeRead({ id: noticeData.value.id }).then(res => {
            console.log(res)
        })
    } else {
        // 如果没有勾选则删除此缓存内容
        // localStorage.removeItem("nextTime")
    }
    emit('close')
}

onMounted(() => {
    if (props.type == 'default') {
        api.noticeData().then(res => {
            if (res.code == 200) {
                if (res.data && !Array.isArray(res.data)) {
                    noticeData.value = res.data
                    show.value = true
                }
            } else {
                show.value = false
                emit('close')
            }
        })
    } else if (props.type == 'preview') {
        // 预览模式
        noticeData.value = props.data
        show.value = true
    }
})

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
    const editor = editorRef.value
    if (editor == null) return
    editor.destroy()
})

const handleCreated = editor => {
    editorRef.value = editor // 记录 editor 实例，重要！
}
</script>

<style lang="scss">
// 维护公告
.dialog_stick {
    padding: 0;
    border-radius: 15px;

    .el-dialog__header {
        display: none;
    }

    .dialog_header {
        .header_chat {
            background-image: url('@/assets/dialog/2.png');
            background-size: 100% 100%;
            height: 80px;
            position: relative;

            .chatAi {
                position: absolute;
                right: 80px;
                height: 140px;
                width: auto;
                bottom: -5px;
            }
        }

        .dialog_title {
            font-size: 24px;
            font-weight: 500;
            padding: 20px 40px 5px;
            color: #333;
        }
    }

    .dialog_content {
        padding: 0 40px;
        position: relative;
        z-index: 10;

        .w-e-text-container {
            background-color: transparent;
        }

        .w-e-text-container [data-slate-editor] {
            padding: 0;
        }
    }

    .dialog_footer {
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 20px 40px;

        .dialog_icon {
            height: 140px;
            width: auto;
            position: absolute;
            right: 0;
            bottom: 0;
            z-index: 9;
        }

        .dialog_btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: fit-content;

            .btn {
                width: fit-content;
                padding: 8px 22px;
                background-color: #5180f6;
                color: #fff;
                line-height: 1;
                border-radius: 50px;
                font-size: 13px;
                cursor: pointer;
                user-select: none;
            }

            .tips {
                width: fit-content;
                margin-top: 10px;
                font-size: 12px;
                color: #b3b3b3;
                cursor: pointer;
                user-select: none;
            }
        }
    }
}

// 系统公告
.dialog_main {
    background: transparent;
    background-image: url('@/assets/dialog/3.png');
    background-size: 100% 100%;
    box-shadow: none;

    .el-dialog__header {
        display: none;
    }

    .dialog_header {
        padding: 30px 20px;
        font-weight: 500;
        font-size: 24px;
        color: #00007f;
    }

    .dialog_content {
        padding: 10px 25px;
        margin: 0 20px;
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 15px;
        box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);

        .w-e-text-container {
            background-color: transparent;
        }

        .w-e-text-container [data-slate-editor] {
            padding: 0;
        }
    }

    .dialog_footer {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        padding: 20px 30px 0;

        .dialog_btn {
            display: flex;
            flex-direction: column;
            align-items: center;

            .btn {
                width: fit-content;
                padding: 8px 22px;
                background-color: #5180f6;
                color: #fff;
                line-height: 1;
                border-radius: 50px;
                font-size: 13px;
                cursor: pointer;
                user-select: none;
            }

            .tips {
                width: fit-content;
                font-size: 12px;
                color: #b3b3b3;
                cursor: pointer;
                user-select: none;
            }
        }
    }
}

// 公告3
.dialog_img {
    background: linear-gradient(180deg, #bfeefb 0%, #aac5f7 20%, #ffffff 45%);
    background-size: 100% 100%;
    box-shadow: none;

    .el-dialog__header {
        display: none;
    }

    .dialog_header {
        padding: 60px 0;
        position: relative;

        .img {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: auto;
            transform: rotate(50deg);
        }

        .header_center_title {
            text-align: center;
            font-weight: 500;
            font-size: 24px;
            color: #00007f;
        }
    }

    .dialog_content {
        position: relative;
        z-index: 10;

        .w-e-text-container {
            background-color: transparent;
        }
    }

    .dialog_footer {
        position: relative;
        padding-top: 10px;

        .dialog_icon {
            height: 140px;
            width: auto;
            position: absolute;
            right: 0;
            bottom: 0;
            z-index: 9;
        }

        .dialog_btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: fit-content;

            .btn {
                width: fit-content;
                padding: 8px 22px;
                background-color: #5180f6;
                color: #fff;
                line-height: 1;
                border-radius: 50px;
                font-size: 13px;
                cursor: pointer;
                user-select: none;
            }

            .tips {
                width: fit-content;
                font-size: 12px;
                color: #b3b3b3;
                cursor: pointer;
                user-select: none;
            }
        }
    }
}

// 公告4
.dialog_bubble {
    background: url('@/assets/dialog/7.png');
    background-size: 100% 100%;
    box-shadow: none;
    width: 650px;
    height: 600px;
    position: relative;

    .el-dialog__header {
        display: none;
    }

    .dialog_header {
        position: absolute;
        left: 50%;
        top: 140px;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;

        .img {
            width: 50px;
            height: 50px;
            background-color: #fff;
            border-radius: 50%;
            padding: 5px;
            box-shadow: 0 0 6px 1px #ccc;
        }

        .dialog_title {
            text-align: center;
            font-weight: 500;
            font-size: 24px;
            color: #555;
            margin-top: 15px;
        }
    }

    .dialog_content {
        position: absolute;
        z-index: 10;
        left: 90px;
        right: 90px;
        top: 320px;

        .w-e-text-container {
            background-color: transparent;
        }

        .el-scrollbar {
            .el-scrollbar__wrap {
                height: 180px !important;
                max-height: 180px !important;
            }
        }
    }

    .dialog_footer {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);

        .dialog_btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: fit-content;

            .btn {
                width: fit-content;
                padding: 8px 22px;
                background-color: #fff;
                color: #444;
                line-height: 1;
                border-radius: 50px;
                font-size: 13px;
                cursor: pointer;
                user-select: none;
            }

            .checkboxNull {
                height: 20px;
            }

            .tips {
                width: fit-content;
                font-size: 12px;
                color: #444;
                cursor: pointer;
                user-select: none;
            }
        }
    }
}
</style>
